import { z } from 'zod';
import { CommunicationsSocketSubscribeRequest } from '../../../../../api/generated/models/CommunicationsSocketSubscribeRequest';
import type { CommunicationsSocketSubscribeAck } from '../../../../../api/generated/models/CommunicationsSocketSubscribeAck';
import { schema as requestSchema } from '../../../../../api/generated/schemas/CommunicationsSocketSubscribeRequest';
import { schema as ackSchema } from '../../../../../api/generated/schemas/CommunicationsSocketSubscribeAck';

/** Versioned action from the automatically generated backend contract. */
export const COMMUNICATIONS_SOCKET_SUBSCRIBE_ACTION =
  CommunicationsSocketSubscribeRequest.type.SUBSCRIBE_COMMUNICATIONS_V1;

/** Raw-topic bound from the canonical generated request schema. */
export const SOCKET_SUBSCRIPTION_MAX_TOPICS =
  requestSchema.properties.topics.maxItems;

const requestValidator = z.fromJSONSchema(requestSchema);
const ackValidator = z.fromJSONSchema(ackSchema);
const hasSafeTopicIds = (topics: string[]): boolean =>
  topics.every((topic) => {
    const id = topic.slice(topic.lastIndexOf('.') + 1);
    return Number.isSafeInteger(Number(id)) && String(Number(id)) === id;
  });

/**
 * Validate the generated wire schema before narrowing to the generated API type.
 * JSON Schema cannot express the shared JavaScript safe-integer topic refinement;
 * keep that additional check here, covered by the same topic boundary fixtures.
 */
export const communicationsSocketSubscribeRequestSchema = z
  .custom<CommunicationsSocketSubscribeRequest>(
    (value) => requestValidator.safeParse(value).success
  )
  .refine((value) => hasSafeTopicIds(value.topics));

/** Require the generated authorization proof and valid canonical topic identities. */
export const communicationsSocketSubscribeAckSchema = z
  .custom<CommunicationsSocketSubscribeAck>(
    (value) => ackValidator.safeParse(value).success
  )
  .refine(
    (value) =>
      hasSafeTopicIds(value.payload.topics) &&
      hasSafeTopicIds(value.payload.requestedTopics)
  );
